'use strict';
import {
  getvariableValue,
  validateDateManualEntry
} from '../utilities/utility';
import {
  makeDatepickerAccessible,
  selectmenuAccessibilityCompliance
} from '../utilities/helper';
import { API_REFERENCE } from '../utilities/constant_api';
import { htmlGet, jsonGet, jsonPost } from '../components/ajax';

$(function() {
  const deleteDiagnosisUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountDiagnosis.deleteDiagnosis}`;
  var customerId = $(document)
    .find('#customerId')
    .val();
  window.localStorage.setItem('saveDiagnosis', 'false');
  var updtDt = new Date();
  var previousSelectedDropdownValue = '';
  var surveyQuestionAnswer = {
    customerAccountId: $('.diagSurveycardianlId').val(),
    orderNumber: 'order',
    createdBy:
      $('.diagSurveyfirstName').val() + ' ' + $('.diagSurveylastName').val(),
    updatedBy:
      $('.diagSurveyfirstName').val() + ' ' + $('.diagSurveylastName').val(),
    createStp: updtDt,
    updateStp: updtDt,
    diagnosisAddedBy:
      $('.diagSurveyfirstName').val() + ' ' + $('.diagSurveylastName').val(),
    effectiveStartDate: updtDt,
    surveyQuestionModels: null,
    newToTherapyFlg: null
  };
  var answerList = 'surveyAnswers';
  var dataTypeForInput = 'refKeyValue';
  var dataTypeForSelectionInput = 'controlType';
  var parentForInput = 'dataTypeRefDetail';
  var parentForSelectionInput = 'surveyGroups';
  var questionHeading = 'webDescription';
  var alternateQuestionHeading = 'questionDesc';
  var previouslySelectedQuestionValues = [];
  var previouslySelectedAnswerValues = [];
  var finalSelectedQuestionValues = [];
  var finalSelectedAnswerValues = [];
  var finalSubmission = null;
  var cboxOptions = {
    maxWidthLg: '800px',
    maxHeightLg: '800px',
    maxWidthMd: '800px',
    maxHeightMd: '500px',
    maxWidthSm: '800px',
    maxHeightSm: 'auto'
  };
  var subQuestionJsonFound = null;
  let viewDiagnosisConditionsAjaxReq = true;
  let saveSureveyDiagnosisConditionsAjaxReq = true;
  let removeDiagnosisConditionsAjaxReq = true;
  let diagnosisSurveyDateError = $('#diagnosisSurveyDateError').text();

  function checkWidth() {
    if (window.innerWidth >= 992) {
      return cboxOptions.maxWidthLg;
    } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
      return cboxOptions.maxWidthMd;
    } else {
      return cboxOptions.maxWidthSm;
    }
  }

  function checkHeight() {
    if (window.innerHeight >= 992) {
      return cboxOptions.maxHeightLg;
    } else if (window.innerHeight >= 768 && window.innerHeight < 992) {
      return cboxOptions.maxHeightMd;
    } else {
      return cboxOptions.maxHeightSm;
    }
  }

  function initializeDatepicker(questionId, heading) {
    $('#dischargeDate').datepicker({
      showOn: 'button',
      buttonImage:
        '/_ui/responsive/theme-edgepark/images/external/icon_calendar_darkgray.svg',
      buttonImageOnly: true,
      buttonText: 'Select date',
      onSelect: function onSelect(date) {
        const id = String(questionId);
        $('input[name=' + id + ']').val(date);
        $('.diagnosisSurvey-remove__icon').focus();
      },
      minDate: '-365d',
      maxDate: '+365d',
      beforeShow: function() {
        makeDatepickerAccessible($('.diagnosisSurvey-remove__icon'));
      },
      onClose: function() {
        $(this)
          .next('.ui-datepicker-trigger')
          .focus();
      },
      onChangeMonthYear: function() {
        setTimeout(function() {
          makeDatepickerAccessible($('.diagnosisSurvey-remove__icon'));
        }, 200);
      }
    });
    $('.ui-datepicker-trigger')
      .attr('tabindex', 0)
      .attr('role', 'button');
  }

  function diagnosisSurveyQuestion() {
	if ($('#categoryDropdown').val() == 48) {
      $('#fieldset').prop('hidden', true);
    } else {
      $('#fieldset').prop('hidden', false);
    }
    $('.generic-error-container').addClass('hidden');
    const getDiagnosisQuestionsUrl = `${ACC.config.encodedContextPath}${
      API_REFERENCE.accountDiagnosis.diagnosisQuestions
    }?surveyCategoryId=${$('#categoryDropdown').val()}`;
    jsonGet(getDiagnosisQuestionsUrl).then(data => {
      if (
        data.length === 1 &&
        data[0].errorMessage !== undefined &&
        data[0].errorMessage !== null
      ) {
        $('.generic-error-container .generic-error-text').text(
          data[0].errorMessage
        );
        $('.generic-error-container').removeClass('hidden');
        window.scrollTo(0, 0);
      } else {
        $('.diagnnosisSaveDisable').removeAttr('disabled');
        $('.required_form').hide();
        finalSubmission = data;
        data.map(function(question) {
          var heading =
            question[questionHeading] && question[questionHeading].length > 1
              ? question[questionHeading]
              : question[alternateQuestionHeading];
          heading = heading && heading.length > 0 ? heading : '';
          deciderFn(question, heading);
        });
      }
      if ($('#categoryDropdown').val() == '48') {
        $(
          $('.prequestion__electronic-order-documents-checkbox').find(
            '.diagnosisSurvey__checkbox'
          )[0]
        )
          .find('.select-option-survey-answer-checkbox')
          .trigger('click');
      }
    });
  }

  function reloadConditionSection() {
    const viewDiagnosisUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountDiagnosis.viewConditions}`;
    if (location.pathname.indexOf('checkout') < 0) {
      $('.generic-error-container').addClass('hidden');
      if (!viewDiagnosisConditionsAjaxReq) return false;
      viewDiagnosisConditionsAjaxReq = false;
      htmlGet(viewDiagnosisUrl)
        .then(data => {
          viewDiagnosisConditionsAjaxReq = true;
          const sanitizedData = ACC.sanitizer.sanitizeHtmlDeeply(data);
          const diagnosisErrorMsg = $(sanitizedData).find(
            '.diagnosis-error-message'
          );
          if (diagnosisErrorMsg.length > 0) {
            $('.generic-error-container .generic-error-text').text(
              $('.diagnosis-error-message').val()
            );
            $('.generic-error-container').removeClass('hidden');
            window.scrollTo(0, 0);
          } else {
            $('.authorized-contacts-container').replaceWith(sanitizedData);
            $('#diagnosisAuthContent .account-info-accordion-toggler').trigger(
              'click'
            );
          }
        })
        .catch(error => {
          viewDiagnosisConditionsAjaxReq = true;
        });
    } else {
      window.location.reload(true);
    }
  }

  function surveyQuestionPresent(state) {
    return '';
  }

  function textAreaListFn(heading, subject, required, questionId) {
    const sanitizeSubject = ACC.sanitizer.sanitizeHtmlDeeply(subject);
    const htmlText = `<div class="col-xs-12 col-md-6 diagnosisSurvey__questions">
      <h6 class="diagnosisSurvey__questions--labels mb-1">
       ${heading}
       ${
         required == 'required'
           ? '<span class="diagnosisSurvey__requiredfields--red">*</span>'
           : ''
       } 
     </h6>
   </div>
   <div class="col-xs-12 form-group">
       <div class="col-xs-12 col-md-12 date-input">
           <div for="surveySubNumber" class="diagnosisSurvey__date col-xs-12 pl-0">
             <textarea required maxlength="250" rows="4" cols="50" wrap="physical" data-questionid="${questionId}" id="surveySubNumber" class="form-control col-xs-12 col-md-7 pb-2 font_input_normal" 
             aria-label="${heading}"></textarea>
         </div>
       </div>
   </div>`;
    $(sanitizeSubject).append(ACC.sanitizer.sanitizeHtmlDeeply(htmlText));
  }

  function textBoxListFn(heading, subject, required, questionId) {
    const sanitizeSubject = ACC.sanitizer.sanitizeHtmlDeeply(subject);
    const htmlData = `<div class="col-xs-12 col-md-6 diagnosisSurvey__questions">
      <h6 class="diagnosisSurvey__questions--labels mb-1">
      ${heading} ${
      required == 'required'
        ? '<span class="diagnosisSurvey__requiredfields--red">*</span>'
        : ''
    }
     </h6>
    </div>
    <div class="col-xs-12 form-group">
      <div class="col-xs-12 col-md-12 date-input">
        <div class="diagnosisSurvey__date col-xs-12 pl-0">
          <input type="text" required data-questionid="${questionId}" maxlength="250"
          id="surveySubNumber"
          class="form-control col-xs-12 col-md-7 pb-2 font_input_normal" aria-label="${heading}"/>
        </div>
        </div>
        </div>`;
    $(sanitizeSubject).append(ACC.sanitizer.sanitizeHtmlDeeply(htmlData));
  }

  function numberListFn(heading, subject, required, questionId) {
    const sanitizeSubject = ACC.sanitizer.sanitizeHtmlDeeply(subject);
    const htmlData = `<div class="col-xs-12 col-md-6 diagnosisSurvey__questions">
    <h6 class="diagnosisSurvey__questions--labels mb-1">
      ${heading} 
      ${
        required == 'required'
          ? '<span class="diagnosisSurvey__requiredfields--red">*</span>'
          : ''
      }
        </h6>
        </div>
      <div class="col-xs-12 form-group">
       <div class="col-xs-12 col-md-12 date-input">
        <label for="surveySubNumber" class="diagnosisSurvey__date col-xs-12 pl-0">
          <input type="text" required data-questionid="${questionId}" id="surveySubNumber"
          class="form-control col-xs-12 col-md-7 pb-2  number_only" aria-label="${heading}"/>
        </label>
        </div>
      </div>`;
    $(sanitizeSubject).append(ACC.sanitizer.sanitizeHtmlDeeply(htmlData));
  }

  function datpickerListFn(heading, subject, required, questionId) {
    const sanitizeSubject = String(subject);
    const htmlData = `<div class="col-xs-12 col-md-6 diagnosisSurvey__questions">
    <h6 class="diagnosisSurvey__questions--labels mb-1">
      ${heading}
      ${
        required == 'required'
          ? '<span class="diagnosisSurvey__requiredfields--red">*</span>'
          : ''
      }
      </h6>
      </div>
      <div class="form-group">
       <div class="col-xs-12 col-md-12 date-input">
        <label for="dischargeDate" class="diagnosisSurvey__date col-xs-12 pl-0">    
          <input type="text" readonly="readonly" required id="dischargeDate" aria-label="${heading}" data-questionid="${questionId}" name="${questionId}" placeholder="mm/dd/yyyy"
      class="form-control col-xs-12 col-md-7 pb-2 demographicsCustomerDateOfBirth dateOfBirth custom-valid-input" autocomplete="off" 
      value=""/>
      <div class="dianosis-date-error error-msg-text hidden">${diagnosisSurveyDateError}</div>
      </label>
      </div>
      <div class="error-msg-text-date-range error-msg-text" hidden="true" role="alert">
           Please use an infant expected date of birth within a year of today's date.
	  </div>
      </div>`;
    $(sanitizeSubject).append(ACC.sanitizer.sanitizeHtmlDeeply(htmlData));
    setMaxTodaysDate();
    initializeDatepicker(questionId, heading);
    $('.demographicsCustomerDateOfBirth').datepicker(
      'option',
      'onSelect',
      checkManualDateValidity
    );
  }

  function radioListFn(heading, content, subject, questionId, required) {
    const sanitizeSubject = String(subject);
    const htmlData = '<div class="col-xs-12 col-md-12 pl-0 mb-5">\n  <fieldset>\n <legend>\n <div class="col-xs-12 col-md-12 diagnosisSurvey__questions">\n      <h6 class="diagnosisSurvey__questions--labels mb-1">\n      '
      .concat(heading, '\n      ')
      .concat(
        required == 'required'
          ? '<span class="diagnosisSurvey__requiredfields--red">*</span> '
          : '',
        '\n      </h6>\n    </div>\n  </legend>\n  '
      )
      .concat(
        content
          .map(function(item, i) {
            return '\n    <div class="col-xs-12 col-md-8 diagnosisSurvey__radio selection-group mb-2">\n      <input '
              .concat(required, ' data-questionid="')
              .concat(questionId, '" type="radio" name="')
              .concat(
                questionId,
                '" class="select-option-survey-answer-radio"  aria-label="'
              )
              .concat(content[i]['description'], '" value="')
              .concat(
                content[i]['surveyAnswerId'],
                '"/>\n      <label class="pl-3 diagnosisSurvey__radio--options"\n        >\n        '
              )
              .concat(content[i]['description'], '\n        ')
              .concat(
                content[i]['surveySubQuestions']
                  ? surveyQuestionPresent(content[i])
                  : surveyQuestionPresent(content[i]),
                '</label\n      >\n    </div>\n'
              );
          })
          .join(''),
        ''
      )
      .concat(
        content
          .map(function(item, i) {
            return `\n <input class="${content[i]['surveyAnswerId']}" hidden />\n
        <div id="${content[i]['surveyAnswerId']}" class="sublevel col-md-12">
        </div>\n`;
          })
          .join(''),
        '\n </fieldset>\n </div>\n '
      );
    $(sanitizeSubject).append(ACC.sanitizer.sanitizeHtmlDeeply(htmlData));
  }

  function checkboxListFn(heading, content, subject, questionId, required) {
    const sanitizeSubject = String(subject);
    const htmlData = '<div class="col-xs-12 col-md-12 pl-0 mb-5">\n <fieldset>\n <legend>\n  <div class="col-xs-12 col-md-6 diagnosisSurvey__questions">\n      <h6 class="diagnosisSurvey__questions--labels mb-4 mt-0">\n        '
      .concat(heading, '\n        ')
      .concat(
        required == 'required'
          ? '<span class="diagnosisSurvey__requiredfields--red">*</span> '
          : '',
        '\n      </h6>\n    </div>\n  </legend>\n  <div class="col-xs-12 col-md-8">\n      <form class="prequestion__electronic-order-documents-checkbox">\n <ul style="list-style-type:none" class="pl-0">   '
      )
      .concat(
        content
          .map(function(item, i) {
            return '\n         <li> <div class="form-check selection-group diagnosisSurvey__checkbox">\n            <div class="pl-0 pt-2 d-flex"\n              ><input\n              data-questionid="'
              .concat(
                questionId,
                '"\n                type="checkbox"\n                '
              )
              .concat(required, '\n                aria-label="')
              .concat(content[i]['description'], '"\n                name="')
              .concat(questionId, '"\n                data-value="')
              .concat(
                content[i]['surveyAnswerId'],
                '"\n                class="prequestion-custom-checkbox prefferredShippingAddress select-option-survey-answer-checkbox"\n              />\n            <label class="pl-5 prequestion-checkbox-answer">\n'
              )
              .concat(content[i]['description'], '\n              ')
              .concat(
                content[i]['surveySubQuestions']
                  ? surveyQuestionPresent(content[i])
                  : surveyQuestionPresent(content[i]),
                '\n              <input class="'
              )
              .concat(
                content[i]['surveyAnswerId'],
                '" hidden />\n              <div id="'
              )
              .concat(
                content[i]['surveyAnswerId'],
                '" class="sublevel"> </div>\n              </label>\n            </div>\n          </div></li>'
              );
          })
          .join(''),
        '\n          </div>\n     </ul> </form>\n    </div>\n </fieldset>\n </div>\n  '
      );
    $(sanitizeSubject).append(ACC.sanitizer.sanitizeHtmlDeeply(htmlData));
  }

  function dropDownListFn(heading, content, subject, questionId, required) {
    const sanitizeSubject = String(subject);
    const htmlData = '<div class="col-xs-12 col-md-12 pl-0 mb-5">\n    <div class="col-xs-12 col-md-12 diagnosisSurvey__questions">\n      <h6 class="diagnosisSurvey__questions--labels mb-1">\n        '
      .concat(heading, '\n        ')
      .concat(
        required == 'required'
          ? '<span class="diagnosisSurvey__requiredfields--red">*</span> '
          : '',
        '\n      </h6>\n    </div>\n    <div class="col-xs-12 col-md-12 dropdown">\n      <select '
      )
      .concat(required, ' data-questionid="')
      .concat(
        questionId,
        '" class="diagnosisSurvey-dropdown col-xs-12 col-md-7 select-option-survey-answer-dropdown" aria-label="'
      )
      .concat(
        heading,
        '">\n      <option value="Select" disabled selected hidden>Select</option>\n      '
      )
      .concat(
        content
          .map(function(item, i) {
            return '\n          <option value="'
              .concat(content[i]['surveyAnswerId'], '">\n          ')
              .concat(content[i]['description'], '\n          </option>');
          })
          .join(''),
        '\n      </select>\n      '
      )
      .concat(
        content
          .map(function(item, i) {
            return '\n      '
              .concat(
                content[i]['surveySubQuestions']
                  ? surveyQuestionPresent(content[i])
                  : surveyQuestionPresent(content[i]),
                '\n              <input class="'
              )
              .concat(
                content[i]['surveyAnswerId'],
                '" hidden />\n              <div id="'
              )
              .concat(
                content[i]['surveyAnswerId'],
                '" class="sublevel"> </div>'
              );
          })
          .join(''),
        '\n    </div>\n  </div>\n  '
      );
    $(sanitizeSubject).append(ACC.sanitizer.sanitizeHtmlDeeply(htmlData));
    $('.select-option-survey-answer-dropdown').selectmenu();
    selectmenuAccessibilityCompliance();
  }

  function generateHtmlDocument(task, heading, subject) {
    var required = null;
    if (task['requiredFlg'] == 1) required = 'required';
    else required = '';

    if (
      task[parentForSelectionInput] == undefined ||
      task[parentForSelectionInput] == null
    ) {
      if (task[parentForInput][dataTypeForInput] == 'Date') {
        datpickerListFn(heading, subject, required, task['surveyQuestionId']);
      }

      if (task[parentForInput][dataTypeForInput] == 'Number') {
        numberListFn(heading, subject, required, task['surveyQuestionId']);
      }
      if (task[parentForInput][dataTypeForInput] == 'Text') {
        textBoxListFn(heading, subject, required, task['surveyQuestionId']);
      }
      if (task[parentForInput][dataTypeForInput] == 'Text Area') {
        textAreaListFn(heading, subject, required, task['surveyQuestionId']);
      }
    } else {
      if (
        task[parentForSelectionInput][dataTypeForSelectionInput] ==
        'RadioButtonList'
      ) {
        radioListFn(
          heading,
          task[parentForSelectionInput][answerList],
          subject,
          task['surveyQuestionId'],
          required
        );
      }

      if (
        task[parentForSelectionInput][dataTypeForSelectionInput] ==
        'CheckBoxList'
      ) {
        checkboxListFn(
          heading,
          task[parentForSelectionInput][answerList],
          subject,
          task['surveyQuestionId'],
          required
        );
      }

      if (
        task[parentForSelectionInput][dataTypeForSelectionInput] ==
        'DropDownList'
      ) {
        dropDownListFn(
          heading,
          task[parentForSelectionInput][answerList],
          subject,
          task['surveyQuestionId'],
          required
        );
      }
    }
  }

  function setMaxTodaysDate() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!

    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    today = yyyy + '-' + mm + '-' + dd;
  }

  function checkManualDateValidity() {
    let $errorMsg = $('.error-msg-text-date');
    let $errorMesgRange = $('.error-msg-text-date-range');
    if (!$(this).val().length) {
      $errorMsg.hide();
      return false;
    }
    let dateValid = validateDateManualEntry($(this).val());
    if (!dateValid) {
      $errorMsg.show();
    } else {
      $errorMsg.hide();
    }
    let dateValidRange = validateDateRange($(this).val());
    if (!dateValidRange) {
      $errorMesgRange.show();
    } else {
      $errorMesgRange.hide();
    }
  }

  function validateDateRange(dateEntered) {
    var date1 = new Date(dateEntered);
    var date = new Date();
    var difference_In_Time = date.getTime() - date1.getTime();
    var difference_In_Days = Math.floor(difference_In_Time / (1000 * 3600 * 24));

    if (difference_In_Days <= 365 && difference_In_Days >= -365) {
      return true;
    } else {
      return false;
    }
  }

  function formatDate() {
    $(this).val(
      $(this)
        .val()
        .replace(/^(\d\d)(\d)$/g, '$1/$2')
        .replace(/^(\d\d\/\d\d)(\d+)$/g, '$1/$2')
        .replace(/[^\d\/]/g, '')
    );
  }

  function deciderFn(task, heading) {
    var subject = '.surveyFormStart';
    generateHtmlDocument(task, heading, subject);
  }

  function deciderSubFn(subAnswer) {
    subQuestionJsonFound = null;
    var parsedObj = subAnswer;
    var subject = String(`#${parsedObj['surveyAnswerId']}`);
    var deletableBranchNew = $(subject).next()[0];

    if (
      deletableBranchNew != undefined &&
      $(previousSelectedDropdownValue).next().length > 0
    ) {
      var deletableBranch = $(previousSelectedDropdownValue).next()[0];
      var htmlcollection = deletableBranch.children;

      if (
        (deletableBranchNew.parentNode == deletableBranch.parentNode) ==
        true
      ) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (
            var _iterator = htmlcollection[Symbol.iterator](), _step;
            !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
            _iteratorNormalCompletion = true
          ) {
            var collection = _step.value;
            collection.remove();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (deletableBranch.firstElementChild)
          deletableBranch.firstElementChild.remove();
      }
    }

    previousSelectedDropdownValue = subject;

    if (
      parsedObj['surveySubQuestions'] != undefined ||
      parsedObj['surveySubQuestions'] != null
    ) {
      parsedObj['surveySubQuestions'].map(function(task) {
        var heading =
          task[questionHeading] && task[questionHeading].length > 1
            ? task[questionHeading]
            : task[alternateQuestionHeading];
        heading = heading && heading.length > 0 ? heading : '';
        generateHtmlDocument(task, heading, subject);
      });
    }
  }

  function getFianlSelectedAnswers(selectedElement) {
    if (window.localStorage.getItem('saveDiagnosis') == 'false') {
      if (selectedElement.hasClass('select-option-survey-answer-checkbox')) {
        if (selectedElement.is(':checked')) {
          finalSelectedQuestionValues.push(
            selectedElement.attr('data-questionid')
          );
          finalSelectedAnswerValues.push(selectedElement.attr('data-value'));
        } else {
          finalSelectedQuestionValues.splice(
            finalSelectedAnswerValues.lastIndexOf(
              selectedElement.attr('data-value')
            ),
            1
          );
          finalSelectedAnswerValues.splice(
            finalSelectedAnswerValues.lastIndexOf(
              selectedElement.attr('data-value')
            ),
            1
          );
        }
      } else {
        if (
          finalSelectedQuestionValues.lastIndexOf(
            selectedElement.attr('data-questionid')
          ) > -1
        ) {
          finalSelectedAnswerValues.splice(
            finalSelectedQuestionValues.lastIndexOf(
              selectedElement.attr('data-questionid')
            ),
            1
          );
          finalSelectedQuestionValues.splice(
            finalSelectedQuestionValues.lastIndexOf(
              selectedElement.attr('data-questionid')
            ),
            1
          );
        }

        finalSelectedQuestionValues.push(
          selectedElement.attr('data-questionid')
        );
        finalSelectedAnswerValues.push(selectedElement.val());
      }
    }
  }

  function getObjectData() {
    if (window.localStorage.getItem('saveDiagnosis') == 'false') {
      var selectedElement = $(this);
      getFianlSelectedAnswers(selectedElement);

      if ($(this).hasClass('select-option-survey-answer-checkbox')) {
        var deletableBranch = $('.' + $(this).attr('data-value')).next()[0];
        if (deletableBranch && deletableBranch.children) {
          var htmlcollection = deletableBranch.children;

          if (!$(this).is(':checked')) {
            if (
              finalSelectedAnswerValues.indexOf(deletableBranch.id.toString()) >
              -1
            ) {
              finalSelectedAnswerValues.splice(
                finalSelectedAnswerValues.indexOf(
                  deletableBranch.id.toString()
                ),
                1
              );
            }

            $('#' + deletableBranch.id)
              .find('input')
              .each(function() {
                if (
                  finalSelectedAnswerValues.indexOf(
                    $(this).attr('data-value')
                  ) > -1
                ) {
                  finalSelectedAnswerValues.splice(
                    finalSelectedAnswerValues.indexOf(
                      $(this).attr('data-value')
                    ),
                    1
                  );
                }

                if (
                  finalSelectedQuestionValues.indexOf(
                    $(this).attr('data-questionid')
                  ) > -1
                ) {
                  finalSelectedQuestionValues.splice(
                    finalSelectedQuestionValues.indexOf(
                      $(this).attr('data-questionid')
                    ),
                    1
                  );
                }
              });
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (
                var _iterator2 = htmlcollection[Symbol.iterator](), _step2;
                !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next())
                  .done);
                _iteratorNormalCompletion2 = true
              ) {
                var collection = _step2.value;
                collection.remove();
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            if (deletableBranch.firstElementChild)
              deletableBranch.firstElementChild.remove();
          } else {
            previouslySelectedQuestionValues.push(
              $(this).attr('data-questionid')
            );
            previouslySelectedAnswerValues.push(
              '.' + $(this).attr('data-value')
            );
            var answerIdToBeSearched = $(this).attr('data-value');
            getSubQuestionJson(finalSubmission, answerIdToBeSearched);
            deciderSubFn(subQuestionJsonFound);
          }
        }
      } else if (
        previouslySelectedQuestionValues.lastIndexOf(
          $(this).attr('data-questionid')
        ) > -1 &&
        !$(this).hasClass('select-option-survey-answer-checkbox')
      ) {
        if (
          $(
            previouslySelectedAnswerValues[
              previouslySelectedQuestionValues.lastIndexOf(
                $(this).attr('data-questionid')
              )
            ]
          ).next().length > 0
        ) {
          var _deletableBranch = $(
            previouslySelectedAnswerValues[
              previouslySelectedQuestionValues.lastIndexOf(
                $(this).attr('data-questionid')
              )
            ]
          ).next()[0];

          $('#' + _deletableBranch.id)
            .find('input')
            .each(function() {
              if (finalSelectedAnswerValues.indexOf($(this).val()) > -1) {
                finalSelectedAnswerValues.splice(
                  finalSelectedAnswerValues.indexOf($(this).val()),
                  1
                );
              }

              if (
                finalSelectedQuestionValues.indexOf(
                  $(this).attr('data-questionid')
                ) > -1
              ) {
                finalSelectedQuestionValues.splice(
                  finalSelectedQuestionValues.indexOf(
                    $(this).attr('data-questionid')
                  ),
                  1
                );
              }
            });
          $('#' + _deletableBranch.id).empty();
        }
      }
    }
  }

  function getSubQuestionJson(finalJson, answerId) {
    finalJson.forEach(function(dataValue) {
      if (dataValue.surveyGroups != null) {
        dataValue.surveyGroups.surveyAnswers.forEach(function(answer) {
          if (answer.surveyAnswerId.toString() == answerId) {
            subQuestionJsonFound = answer;
          }
        });
        if (dataValue.surveyGroups.surveyAnswers.length > 0) {
          dataValue.surveyGroups.surveyAnswers.forEach(function(dataElement) {
            if (dataElement.surveySubQuestions) {
              getSubQuestionJson(dataElement.surveySubQuestions, answerId);
            }
          });
        }
      }
    });
  }

  function populateForm() {
    previouslySelectedQuestionValues.push($(this).attr('data-questionid'));
    previouslySelectedAnswerValues.push('.' + $(this).val());
    var answerIdToBeSearched = $(this).val();
    getSubQuestionJson(finalSubmission, answerIdToBeSearched);
    deciderSubFn(subQuestionJsonFound);
  }

  function getPreviousSelectedValue() {
    previousSelectedDropdownValue = '.' + $(this).val();
  }

  var formValidated = false;

  function validateRequiredFields() {
    var isEmpty = false;
    var textEntered = true;
    var dateSelected = true;
    var radioSelected = true;
    var drodownSelected = true;
    var checkboxSelected = true;
    var textAreaEntered = true;
    var validDateFormat = true;

    if ($('.survey_modal_resolve input[type=text]:required').length > 0) {
      textEntered = true;
      $('.survey_modal_resolve input[type=text]:required').each(function() {
        if ($(this).val() === '') textEntered = false;
      });
    }

    if ($('.survey_modal_resolve textarea:required').length > 0) {
      textAreaEntered = true;
      $('.survey_modal_resolve textarea:required').each(function() {
        if ($(this).val() === '') textAreaEntered = false;
      });
    }

    if ($('.survey_modal_resolve input[type=date]:required').length > 0) {
      dateSelected = true;
      $('.survey_modal_resolve input[type=date]:required').each(function() {
        if ($(this).val() === '') dateSelected = false;
      });
    }

    if ($('.survey_modal_resolve input[type=radio]:required').length > 0) {
      radioSelected = true;
      $('.survey_modal_resolve input[type=radio]:required').each(function() {
        var name = $(this).attr('name');

        if ($('input:radio[name=' + name + ']:checked').length == 0) {
          radioSelected = false;
        }
      });
    }

    if ($('.survey_modal_resolve select:required').length > 0) {
      drodownSelected = true;
      $('.survey_modal_resolve select:required').each(function() {
        if ($(this).val() === '' || $(this).val() === null)
          drodownSelected = false;
      });
    }

    var requiredCheckboxes = $('.survey_modal_resolve :checkbox[required]');

    if (requiredCheckboxes.length > 0) {
      requiredCheckboxes.on('change', function(e) {
        var checkboxGroup = requiredCheckboxes.filter(
          '[name="' + $(this).attr('name') + '"]'
        );
        var isChecked = checkboxGroup.is(':checked');
        if (!isChecked) checkboxSelected = false;
        checkboxGroup.prop('required', !isChecked);
      });
      requiredCheckboxes.trigger('change');
    }

    $('.demographicsCustomerDateOfBirth').each(function() {
      if ($(this).val() !== '' && validDateFormat) {
        validDateFormat = validateDateManualEntry($(this).val());
        if (validDateFormat) {
          validDateFormat = validateDateRange($(this).val());
        }
      }
    });

    if (
      radioSelected &&
      drodownSelected &&
      dateSelected &&
      textEntered &&
      checkboxSelected &&
      textAreaEntered
    )
      isEmpty = false;
    else isEmpty = true;

    if (isEmpty) {
      formValidated = false;
      $('.required_form').show();
    } else {
      formValidated = true;
      $('.required_form').hide();
      if (!validDateFormat) {
        formValidated = false;
      }
    }
  }

  function iterateFinalObject(finalSubmissionIter) {
    finalSubmissionIter.forEach(function(dataValue) {
      if (dataValue.surveyGroups == null) {
        const questionId = String(dataValue.surveyQuestionId);
        if ($(`[data-questionid=${questionId}]`).val().length > 0) {
          dataValue['enteredAnswer'] = $(
            `[data-questionid=${questionId}]`
          ).val();
        } else {
          delete finalSubmission[finalSubmission.indexOf(dataValue)];
          finalSubmission = finalSubmission.filter(Boolean);
        }
      } else {
        if (
          finalSelectedQuestionValues.indexOf(
            dataValue.surveyQuestionId.toString()
          ) !== -1
        ) {
          dataValue.surveyGroups.surveyAnswers.forEach(function(answer) {
            if (
              !(
                finalSelectedAnswerValues.indexOf(
                  answer.surveyAnswerId.toString()
                ) !== -1
              )
            ) {
              delete dataValue.surveyGroups.surveyAnswers[
                dataValue.surveyGroups.surveyAnswers.indexOf(answer)
              ];
            }

            dataValue.surveyGroups.surveyAnswers = dataValue.surveyGroups.surveyAnswers.filter(
              Boolean
            );
          });

          if (dataValue.surveyGroups.surveyAnswers.length > 0) {
            dataValue.surveyGroups.surveyAnswers.forEach(function(dataElement) {
              if (dataElement.surveySubQuestions) {
                iterateFinalObject(dataElement.surveySubQuestions);
              }
            });
          }
        } else {
          delete finalSubmission[finalSubmission.indexOf(dataValue)];
          finalSubmission = finalSubmission.filter(Boolean);
        }
      }
    });
    surveyQuestionAnswer.surveyQuestionModels = finalSubmission;
  }

  function createSubmitObject() {
    window.localStorage.setItem('saveDiagnosis', 'true');
    validateRequiredFields();

    if (formValidated) {
      iterateFinalObject(finalSubmission);
      surveyQuestionAnswer.customerAccountId = parseInt(
        $('.diagSurveycardianlId').val()
      );
      surveyQuestionAnswer.createdBy =
        $('.diagSurveyfirstName').val() + ' ' + $('.diagSurveylastName').val();
      surveyQuestionAnswer.updatedBy =
        $('.diagSurveyfirstName').val() + ' ' + $('.diagSurveylastName').val();
      surveyQuestionAnswer.diagnosisAddedBy =
        $('.diagSurveyfirstName').val() + ' ' + $('.diagSurveylastName').val();
      if ($('input[name="optradio_diagnosis"]:checked').val() === 'yes') {
        surveyQuestionAnswer.newToTherapyFlg = true;
      } else {
        surveyQuestionAnswer.newToTherapyFlg = false;
      }
      $('.generic-error-container').addClass('hidden');

      if (
        surveyQuestionAnswer.surveyQuestionModels[0].surveyCategoryId === 48
      ) {
        if (surveyQuestionAnswer.surveyQuestionModels.length === 3) {
          if (
            surveyQuestionAnswer.surveyQuestionModels[1].surveyGroups
              .surveyAnswers.length === 0
          ) {
            $('.required_form').show();
            return false;
          }          
        }
        else
        {
          $('.required_form').show();
          return false;
        }
      }
      

      const saveSurveyAnswersUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountDiagnosis.saveSurveyAnswers}`;
      const saveSurveyData = JSON.stringify(surveyQuestionAnswer);
      if (!saveSureveyDiagnosisConditionsAjaxReq) return false;
      saveSureveyDiagnosisConditionsAjaxReq = false;
      jsonPost(saveSurveyAnswersUrl, saveSurveyData)
        .then(data => {
          saveSureveyDiagnosisConditionsAjaxReq = true;
          if (
            data.length === 1 &&
            data[0].errorMessage !== undefined &&
            data[0].errorMessage !== null
          ) {
            $('.generic-error-container .generic-error-text').text(
              data[0].errorMessage
            );
            $('.generic-error-container').removeClass('hidden');
            window.scrollTo(0, 0);
          } else {
            if (location.pathname.indexOf('checkout') < 0) {
              reloadConditionSection();
            } else {
              let diagnosisCheckoutForm = getvariableValue(
                'checkoutDiagnosisForm'
              );
              if (diagnosisCheckoutForm != undefined) {
                $(document.body).append(diagnosisCheckoutForm);
                diagnosisCheckoutForm.submit();
              } else {
                window.location.reload(true);
              }
            }
            previouslySelectedQuestionValues = [];
            previouslySelectedAnswerValues = [];
            finalSelectedQuestionValues = [];
            finalSelectedAnswerValues = [];
            finalSubmission = null;
            window.localStorage.setItem('saveDiagnosis', 'false');
          }
        })
        .catch(error => {
          saveSureveyDiagnosisConditionsAjaxReq = true;
          window.localStorage.setItem('saveDiagnosis', 'false');
        });
    } else {
      window.localStorage.setItem('saveDiagnosis', 'false');
    }
  }

  function deleteDiagnosis() {
    const completeDeleteDiagnosisUrl = `${deleteDiagnosisUrl}?diagnosisId=${$(
      this
    ).attr('id')}`;
    if (!removeDiagnosisConditionsAjaxReq) return false;
    removeDiagnosisConditionsAjaxReq = false;
    jsonGet(completeDeleteDiagnosisUrl)
      .then(result => {
        removeDiagnosisConditionsAjaxReq = true;
        ACC.colorbox.open('', {
          html: result.removeDiagnosis,
          onLoad: $('#cboxOverlay').css('position', 'fixed'),
          width: checkWidth(),
          height: checkHeight(),
          className: 'customer-auth__modal'
        });
      })
      .catch(error => {
        removeDiagnosisConditionsAjaxReq = true;
      });
  }

  $(document).on('click', '#btn-remove-diagnosis', function(e) {
    var planId = $('#diagnosisIdToRemove').val();
    var requestData = {
      diagnosisId: planId
    };
    $('.diagnosis-removal-modal-error').addClass('hidden');
    const jsonRequestData = JSON.stringify(requestData);
    jsonPost(deleteDiagnosisUrl, jsonRequestData).then(data => {
      data = JSON.parse(data);
      if (data.status === 'SUCCESS') {
        ACC.colorbox.close();
        reloadConditionSection();
      } else {
        $('.diagnosis-removal-modal-error .generic-error-text').text(
          data.errorMessage
        );
        $('.diagnosis-removal-modal-error').removeClass('hidden');
      }
    });
  });

  function initializeSurveyForm() {
    $('.surveyFormStart').empty();
  }

  $(document).on('keypress', '.number_only', function(e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
  });

  function getChecked() {
    if (this.checked) {
      this.setAttribute('checked', 'checked');
    } else {
      this.removeAttribute('checked');
    }
  }

  function removeDate() {
    $('[data-questionid=' + $(this).attr('data-removeid') + ']').val('');
  }

  function activateDiagnosisSurvey() {
    $('#categoryDropdown').selectmenu();
    if (location.pathname.indexOf('checkout') < 0) {
      $('.survey_modal_resolve').removeAttr('hidden');
      $('.addSurveyLink').attr('hidden', true);
      $('.takeDiagnosisSurvey').click(function() {
        $('#q1c1').prop('checked', 'true');
      });
    }
  }

  function cancelDiagnosisSurvey() {
    reloadConditionSection();
  }

  $(document).on('click', '#dischargeDate', initializeDatepicker);
  $('#dischargeDate').datepicker();
  $(document).on('click', '.diagnosisSurvey-remove__icon', removeDate);
  $(document).on('selectmenuchange', '#categoryDropdown', initializeSurveyForm);
  $('input').on('click', getObjectData);
  $('#diagnosisTooltip').tooltip();
  $('.select-option-survey-answer-dropdown').selectmenu();
  $(document).on(
    'selectmenuchange',
    '.select-option-survey-answer-dropdown',
    getObjectData
  );
  $(document).on(
    'selectmenuchange',
    '.select-option-survey-answer-dropdown',
    populateForm
  );
  $(document).on(
    'focus',
    '.select-option-survey-answer-dropdown',
    getPreviousSelectedValue
  );
  $(document).on('change', '.select-option-survey-answer-radio', getObjectData);
  $(document).on('change', '.select-option-survey-answer-radio', populateForm);
  $(document).on(
    'change',
    '.select-option-survey-answer-checkbox',
    getObjectData
  );
  $(document).on('change', '.select-option-survey-answer-checkbox', getChecked);
  $(document).on(
    'click',
    '.diagnosisSurvey__button--saveContinue',
    createSubmitObject
  );
  $(document).on('click', '.account-insurance-delete-images', deleteDiagnosis);
  $('#categoryDropdown').selectmenu();
  $(document).on(
    'selectmenuchange',
    '#categoryDropdown',
    diagnosisSurveyQuestion
  );
  $(document).on('click', '.takeDiagnosisSurvey', activateDiagnosisSurvey);
  $(document).on(
    'click',
    '.diagnosisSurvey__button--cancel',
    cancelDiagnosisSurvey
  );
  $(document).on(
    'blur input',
    '.demographicsCustomerDateOfBirth',
    checkManualDateValidity
  );
  $(document).on('keyup', '.demographicsCustomerDateOfBirth', formatDate);
});
// $('.account-diagnosis-category-dropdown').selectmenu();
